import { z } from 'zod';

import {
  CalcTypeTransform,
  CollectTypeTransform
} from 'reservations/booking/types';
import { defaultWhenNullish } from 'utility/zod';

const GoogleMapsStaticUrl = z.object({
  static_url_mobile: z.string(),
  static_url_desktop: z.string(),
  static_url_tablet: z.string(),
  lat: z.number(),
  lng: z.number()
});
type GoogleMapsStaticUrl = z.infer<typeof GoogleMapsStaticUrl>;

const LocationConfig = z.object({
  id: z.string().or(z.number()),
  lat: z.string().nullish(),
  lng: z.string().nullish(),
  street: z.string(),
  state: z.string(),
  postal_code: z.string(),
  city: z.string(),
  phone_number: defaultWhenNullish(z.string(), ''),
  email_address: defaultWhenNullish(z.string(), ''),
  name: z.string().default(''),
  slug: z.string(),
  google_maps_static_urls: GoogleMapsStaticUrl,
  fb_location_pixel_id: z.string().nullish(),
  order: z.number()
});
export type LocationConfig = z.infer<typeof LocationConfig>;

const FeePolicyConfig = z.object({
  shouldCollect: z.boolean(),
  calcType: CalcTypeTransform,
  collectType: CollectTypeTransform,
  fee: z.string(),
  minPartySize: z.number(),
  cancelDeadlineMinutes: z.number()
});

export type FeePolicyConfig = z.infer<typeof FeePolicyConfig>;

const SettingsConfig = z.object({
  is_checkless_payments_enabled: z.boolean().default(false),
  waitlist_closed_text: z.string()
});
export type SettingsConfig = z.infer<typeof SettingsConfig>;

const BaseConfig = z.object({
  acceptsParties: z.boolean(),
  featureEnabled: z.boolean(),
  partySizeMax: z.number(),
  partySizeMin: z.number()
});

const BookingConfig = BaseConfig.extend({
  maxAdvanceDays: z.number(),
  minAdvanceMinutes: z.number(),
  slotSize: z.number()
});
export type BookingConfig = z.infer<typeof BookingConfig>;

const WaitlistConfig = BaseConfig;
export type WaitlistConfig = z.infer<typeof WaitlistConfig>;

export const ConfigResponse = z.object({
  inGoodStanding: z.boolean(),
  booking: BookingConfig,
  feePolicy: FeePolicyConfig,
  location: LocationConfig,
  settings: SettingsConfig,
  waitlist: WaitlistConfig
});
export type Config = z.infer<typeof ConfigResponse>;
